import { Row, Col } from "antd";
import {
  Box,
  InputField,
  SubmitButton,
  TextComponent,
} from "../../../../../components";
import styles from "./Seating.module.css";
import { AiOutlineEye } from "react-icons/ai";
import { useEffect, useState } from "react";
import Modal from "../../../../../components/modal/Modal";
import { useLocation, useNavigate } from "react-router-dom";
import SeatingTable from "./SeatingTable/SeatingTable";
import AddVenue from "./AddVenue/AddVenue";
import { useSelector } from "react-redux";

const svgChild = (
  <path
    opacity="0.5"
    d="M435.98 0.1097C675.314 -0.181543 870.824 195.054 871.132 434.611C871.441 674.612 676.427 870.122 436.426 870.414C196.938 870.705 0.982426 675.435 0.828238 436.324C0.656918 195.551 195.327 0.400944 435.98 0.1097ZM160.892 223.493C55.7191 355.118 59.8479 561.747 200.775 691.368C337.214 816.876 532.142 805.09 647.474 710.11C485.475 548.093 323.423 386.024 160.892 223.493ZM224.537 160.088C386.709 322.259 548.948 484.482 711.103 646.636C809.714 525.325 816.447 324.812 682.492 189.983C549.857 56.5081 349.036 59.6262 224.537 160.088Z"
    fill="#ED73AA"
  />
);

const svgViewBox = "0 0 738 658";

const NotAllowedIcon = (
  <svg
    width="100"
    height="100"
    viewBox="0 0 245 245"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M122.066 0.515716C189.166 0.434063 243.98 55.1707 244.066 122.333C244.153 189.621 189.479 244.434 122.191 244.516C55.0481 244.597 0.109666 189.851 0.0664379 122.814C0.0184064 55.31 54.5966 0.59737 122.066 0.515716ZM44.9423 63.144C15.4557 100.047 16.6133 157.977 56.124 194.318C94.3763 229.506 149.027 226.201 181.361 199.573C135.943 154.149 90.5098 108.711 44.9423 63.144ZM62.786 45.3675C108.253 90.8341 153.738 136.315 199.2 181.777C226.847 147.766 228.735 91.5498 191.179 53.749C153.993 16.3277 97.6905 17.2019 62.786 45.3675Z"
      fill="#ED73AA"
    />
  </svg>
);

const ErrorModal = () => {
  return (
    <>
      <Row className={styles.errorModalIcon}>{NotAllowedIcon}</Row>
      <Row className={styles.errorModalTitleRow}>
        <TextComponent textClass={styles.errorModalTitle}>
          Venue Creation
        </TextComponent>
      </Row>
      <Row className={styles.errorModalDescRow}>
        <TextComponent textClass={styles.errorModalDesc}>
          Once a venue is created, it is not possible to create another one
        </TextComponent>
      </Row>
    </>
  );
};

const Seating = () => {
  const [venueCreated, setVenueCreated] = useState(false);
  const [seating, setSeating] = useState(false);
  const [venueModalOpen, setVenueModalOpen] = useState(false);
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const navigate = useNavigate();
  const eventDetails = useSelector(state => state.EventReducer.EventDetails);

  const { state } = useLocation();
  const handleModal = () => {
    if (venueCreated) {
      setErrorModalOpen(true);
    } else {
      setVenueModalOpen(true);
    }
  };

  // console.log("eventDetails", EventDetails);

  useEffect(() => {
    setVenueCreated(false);
  }, []);

  return (
    <>
      {!eventDetails?.venue ? (
        <AddVenue setVenueCreated={setVenueCreated} />
      ) : !seating ? (
        <>
          <Row className={styles.header}>
            <TextComponent textClass={styles.headerText}>Venue</TextComponent>
          </Row>
          <Box boxClass={styles.mainBox}>
            <Row gutter={[32, 16]}>
              <Col xs={24} md={16}>
                <Row className={styles.leftRow}>
                  <Col>
                    <TextComponent textClass={styles.title}>
                      {eventDetails?.name}
                    </TextComponent>
                  </Col>
                  <Col>
                    <Row className={styles.iconRow}>
                      <TextComponent textClass={styles.viewIcon}>
                        <AiOutlineEye />
                      </TextComponent>
                      <TextComponent
                        textClass={styles.venueImageLink}
                        onClick={() =>
                          navigate("/events/eventDetail/guests/venueImage", {
                            state: { headrTitle: "Event Venue",venuImage:eventDetails?.venue?.image },
                          })
                        }
                      >
                        View Venue Image
                      </TextComponent>
                    </Row>
                  </Col>
                  <Col>
                    <Row className={styles.rightRow}>
                      {/* <Row
                        className={styles.uploadImageRow}
                        onClick={() =>
                          navigate("/events/eventDetail/guests/uploadImage", {
                            state: { headrTitle: "Event Venue" },
                          })
                        }
                      >
                        <TextComponent>Upload Image</TextComponent>
                      </Row>
                      <Box
                        boxClass={styles.addVenueBox}
                        onClick={() =>
                          navigate("/events/eventDetail/guests/venueImage", {
                            state: { headrTitle: "Event Venue" },
                          })
                        }
                      >
                        <TextComponent>View Venue Image</TextComponent>
                      </Box> */}
                      <Box
                        boxClass={styles.addVenueBox}
                        onClick={() => setSeating(true)}
                      >
                        <TextComponent>View Seating Table</TextComponent>
                      </Box>
                    </Row>
                  </Col>
                </Row>
              </Col>
              <Col xs={24} md={8} className={styles.colorCol} style={{backgroundImage:`url(${eventDetails?.venue?.image})`}}>
                <Row className={styles.colorColRow}></Row> 
              </Col>
            </Row>
          </Box>

          <Modal
            isModalOpen={errorModalOpen}
            setIsModalOpen={setErrorModalOpen}
            closable={true}
            svgBg={svgChild}
            viewBox={svgViewBox}
            className={styles.modalContent}
          >
            <ErrorModal />
          </Modal>
        </>
      ) : (
        <SeatingTable />
      )}
    </>
  );
};

export default Seating;
